import React, { useEffect, Fragment } from "react";

export default function Interactions(props) {
  useEffect(() => {
    //console.log("interactions mounted!");
  }, []);

  return <Fragment>{props.children}</Fragment>;
}
